<template>
    <div>
        <b-modal
            :visible="value"
            :id="'content-report-modal'"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                Publication Content Report
            </template>

            <copy-to-clipboard-button
                element_id="content_report"
                size="md"
                variant="primary"
                class="float-right"
            />

            <div id="content_report">  <!-- keep this formatting so copy into google docs looks ok -->
                <div class="text-center">
                    <div class="font-weight-bold">{{publication.title}}</div>
                    <div> {{publication.sku}}</div>
                </div>

                <br/>

                <div v-for="(unit_group, index) in report" :key="unit_group.title">
                    {{unit_group.title}}
                    <div class="text-success">
                        Unit {{(index + 1) + '/' + report.length}}
                    </div>
                    Weekly issues <span v-if="unit_group.units">({{unit_group.units.length}})</span>
                    <ul>
                        <li v-for="unit in unit_group.units" :key="unit.title">
                            {{unit.order_number}}. {{unit.title}}
                            <ul>
                                <li>
                                    Articles
                                    <ul>
                                        <li v-for="article in unit.articles" :key="article.title">
                                            {{article.page_slot}}. {{article.title}}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <br/>
                </div>
            </div>

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Close
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import CopyToClipboardButton from '@/components/CopyToClipboardButton'

export default {
    data: () => ({
        report: {}
    }),
    props: [
        'value', 'publication'
    ],
    components: {
        CopyToClipboardButton
    },
    watch: {
        value: {
            handler (value) {
                if (value == true) {
                    this.getReport();
                }
            }
        }
    },
    methods: {
        getReport() {
            this.axios.get('api/publications/content_report/' + this.publication.id)
            .then(response => {
                this.report = response.data
            })
        },
        cancel (event) {
            event.preventDefault()

            this.hide()
        },
        hide () {
            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')
        }
    }
}
</script>
